import React from "react";
import { CardActionArea, Container, Grid, Typography } from "@material-ui/core";
import SubscriptionModal from "../Essentials/SubscriptionModal";
import { Divider } from "antd";
import { Link } from "react-router-dom";
import { GetData } from "../../api/service";
import { Counter } from "../Essentials/WebCounter";
import {
  FacebookFilled,
  YoutubeFilled,
  InstagramFilled,
  MailFilled,
  TwitterOutlined,
} from "@ant-design/icons";

export default function PanduFooter() {
  const [comData, setComData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    GetData(`/getcommittee`).then((resp) => {
      setComData(resp);
      setIsLoaded(true);
    });
  }, []);

  return (
    <div>
      <div className="footer p-4">
        <Container>

          {/* <Divider
            orientation="left"
            style={{ color: "white", borderColor: "white" }}
          >
            CONTACT
          </Divider>
          <br /> */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography variant="h6" style={{ color: "white", fontSize: 16 }}>
                Office Address
              </Typography>
              <div
                style={{
                  height: 2,
                  backgroundColor: "#52B267",
                  width: "60%",
                  marginTop: 10,
                }}
              ></div>
              <br />
              <Typography style={{ color: "white", fontSize: 14 }}>
                Principal
                <br />
                Dispur College,
                <br />
                Dispur, Guwahati-781006,
                <br />
                Assam (India)
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography variant="h6" style={{ color: "white", fontSize: 16 }}>
                Contact Person
              </Typography>
              <div
                style={{
                  height: 2,
                  backgroundColor: "#52B267",
                  width: "60%",
                  marginTop: 10,
                }}
              ></div>
              <br />
              <Typography style={{ color: "white", fontSize: 14 }}>
                Appellate Authority: Dr. Sutibra Malakar <br />
                Designation: Assistant Professor, Dept. of English
                <br />
                Email: sutibra@gmail.com
                <br />
              </Typography>
              <br />
              
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography variant="h6" style={{ color: "white", fontSize: 16 }}>
                Rule & Regulation 
              </Typography>
              <div
                style={{
                  height: 2,
                  backgroundColor: "#52B267",
                  width: "60%",
                  marginTop: 10,
                }}
              ></div>
              <br />
              {/* <Typography variant="overline">KKHSOU</Typography>
              <Typography style={{ color: "white", fontSize: 14 }}>
                Dr. Manjit Kr. Mazumdar
                <br />
                Associate Professor
                <br />
                Geology Department
                <br />
                Phone: 9706433118
              </Typography>
              <Typography variant="overline">IDOL</Typography>
              <Typography style={{ color: "white", fontSize: 14 }}>
                Pradip Chandra Kalita
                <br />
                Assistant Professor
                <br />
                Geography Department
                <br />
                Phone: 98640 42577
              </Typography> */}
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography variant="h6" style={{ color: "white", fontSize: 16 }}>
                Page Statistics
              </Typography>
              <div
                style={{
                  height: 2,
                  backgroundColor: "#52B267",
                  width: "60%",
                  marginTop: 10,
                }}
              ></div>
              <br />

              <Counter />
              <br />

              <Link to="/visitors-note">
                <div
                  style={{
                    border: "solid 2px yellow",
                    width: "50%",
                    padding: 4,
                    textAlign: "center",
                  }}
                >
                  <span style={{ color: "yellow", fontWeight: 700 }}>Visitor's Note</span>
                </div>
              </Link>
              <br />

              <Typography variant="h6" style={{ color: "white", fontSize: 16 }}>
                Social Links
              </Typography>
              <div
                style={{
                  height: 2,
                  backgroundColor: "#52B267",
                  width: "60%",
                  marginTop: 10,
                }}
              ></div>
              <br />

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <a target="_blank" style={{ color: "yellow" }} href="#">
                  <FacebookFilled style={{ fontSize: 25 }} />
                </a>
                &nbsp;
                <a
                  target="_blank"
                  style={{ color: "yellow" }}
                  href={
                    "#"
                  }
                >
                  <InstagramFilled style={{ fontSize: 25 }} />
                </a>
                &nbsp;
                <a
                  target="_blank"
                  style={{ color: "yellow" }}
                  href={"mailto:#"}
                >
                  <MailFilled style={{ fontSize: 25 }} />
                </a>
                &nbsp;
                <a target="_blank" style={{ color: "yellow" }} href={"#"}>
                  <YoutubeFilled style={{ fontSize: 25 }} />
                </a>
                &nbsp;
                <a
                  target="_blank"
                  style={{ color: "yellow" }}
                  href={
                    "#"
                  }
                >
                  <TwitterOutlined style={{ fontSize: 25 }} />
                </a>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundColor: "#202020",
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          fontSize: 14,
        }}
      >
        <Container
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="text-white font-weight-light">
            ©{new Date().getFullYear()} Dispur College. All Rights Reserved.
          </div>
          <div className="text-white font-weight-light">
            Designed & Developed With &#x2764; by Corexx
          </div>
        </Container>
      </div>
    </div>
  );
}
